module.exports = {
  init: function () {

    this.updateNav();

    $(window).scroll(this.updateNav.bind(this));

    const toggles = $('[data-toggle]');

    toggles.click(function (e) {

      e.preventDefault();

      const item = $(e.currentTarget);
      const target = $(item.data('toggle'));

      if (target[0].style.display !== 'none') {
        target.hide();
      } else {
        target.show();
      }

      item.toggleClass('is-active');

    });


    const mobileNavToggles = $('[data-hide-nav]');

    mobileNavToggles.click(function (e) {

      e.preventDefault();

      $('body').removeClass('collapsed');

      $('.js-mobile-menu').hide();
      $('.mobile-nav-toggle').toggleClass('is-active');

    });
  },

  updateNav: function () {
    let distanceY = $(window).scrollTop(),
      shrinkOn = 3,
      navigation = $('.navigation');

    if (distanceY > shrinkOn) {
      navigation.addClass('is-scrolled');
    } else {
      navigation.removeClass('is-scrolled');
    }
  },

}
